export const VulgarismList: string[] = [
  'analnisperk',
  'buzerant',
  'bu.z.n.á.ch',
  'buz.no',
  'coura',
  'c .u..rak',
  'C.U.R.A.K.Y',
  'cu.rvy',
  'CYKLOČŮRÁCI',
  'čub*ka',
  'č-ur-áci',
  'ču*ráci',
  'Čůráci',
  'č u r á k',
  'č..urák',
  'ču.rák',
  'čurák',
  'Č.U.R.Á.K',
  'čúrák',
  'č*ů*r*á*k',
  'č.ů.rák',
  'čůrák',
  'ČŮRÁK',
  'č*u*r*á*k*a',
  'čur.ák; děv.ko',
  'ču rák ku.ndy',
  'čurá.ku',
  'č.ů.ráku',
  'čur.áky',
  'Čurrááci',
  'čůrrák',
  'd e b i l e',
  'd.e.b.i.l.e',
  'd.e.b.i.l.o.v.é',
  'debilové',
  'debilů',
  'demente',
  'děvce',
  'devka',
  'děvka',
  'děvkou',
  'dě-v-ky',
  'děvky',
  'dopice.sk',
  'HOVADA',
  'h.o.v.a.d.o',
  'hov.a-do',
  'hovad.o',
  'hova.do kre+énů',
  'h.o.v.n.a.',
  'hovně',
  'ho..vno',
  'ho.vno',
  'hovno',
  'ho..vnu',
  'HO.V.NU',
  'Hovvnno',
  'howna',
  'i.d.i.o.t.',
  'idiote',
  'i.m.b.e.c.i.l.',
  'jebání',
  'jebat',
  'jeblá',
  'khunda',
  'KHUNDA',
  'kchunda',
  'kchundy',
  'ko*kot',
  'ko.kot',
  'kok.ot',
  'kokot',
  'ko&KOT',
  'k.o.k.o.t.i.',
  'k o k o t ů',
  'kozomrde',
  'kozomrdi',
  'krá-va',
  'kretén',
  'KRETENA',
  'kretene',
  'kreténe',
  'k r e t e n i',
  'kre-téni',
  'kreténi',
  'krypla',
  'kryple',
  'kujva',
  'k.unda',
  'ku n d a',
  'kunda',
  'K U N D A',
  'K*U N D A',
  'kundička',
  'kundo',
  'K u n d o',
  'k.u.n.d.u',
  'kun*dy',
  'kundy',
  'kunnda',
  'K U R E V',
  'kurrva',
  'k u r v a',
  'k.ur.va',
  'kurva',
  'ku.rvám',
  'kurvička',
  'KURVIČKA',
  'kurvit',
  'kurvu',
  'ku*rvy',
  'kurvy',
  'ku.r.wa',
  'kur.wa',
  'kurwa',
  'kurwo',
  'kurwy',
  'kuundo',
  'kůůůůrva',
  'mr-dá',
  'mrd.ačka',
  'mrdat',
  'mrdko',
  'namrda',
  'namrdali',
  'naprcal',
  'nasrat',
  'negr',
  'paz-m.r-de',
  'perdele',
  'pi ča',
  'piča',
  'pí.ča',
  'píča',
  'píččoviny',
  'pi-če',
  'piče',
  'piči',
  'pí či',
  'p i č i z k u r v e n ý',
  'píčo',
  'p í č o v i n a m a',
  'PÍČOVINY',
  'píču',
  'PÍČU',
  'pîču',
  'PiČ US',
  'pííča',
  'pííču',
  'píííča',
  'pojebaná',
  'poosrali',
  'posral',
  'posrali',
  'poštěvák',
  'PRAČUR@K',
  'prcá',
  'pr cal',
  'prcat',
  'PrdeI',
  'prdel',
  'pr-dele',
  'pr..de..le',
  'pr.d.ele',
  'pr.dele',
  'P R D E L E',
  'P.RDELE',
  'promrdali',
  'protiproud.cz',
  'prrdel',
  'prrdeli',
  'py-ča',
  'pýča',
  'PÝČA',
  'pý*čou',
  'pytchy',
  'se-re',
  'sere',
  'ser.e.te',
  'seru',
  'sfi.ňa',
  'SRAAČEK',
  'srackach',
  'sra.ček',
  'sráči',
  'sračka',
  'sračku',
  'sračky',
  'S R A ČKY',
  'SRAČ/KY',
  's r al',
  's.v.i.n.ě.',
  'svi-ně',
  'svině',
  'SVINĚ',
  'šoustá',
  'šoustat',
  'štětka',
  'štětky',
  'šuká',
  'šu...kala',
  'šukat',
  'šuukačka',
  'teplouš',
  'teplouši',
  'ukurvenec',
  'ULTRAZM.RD',
  'umerdala',
  'vyjebaný',
  'v.y.s.r.a.t.',
  'zasranej',
  'ZKR/VE/NÉ/HO',
  'Zkur.ve.ná',
  'z k u r v e n é',
  'zkurvenec',
  'z k u r v e n e j',
  'zkurvený',
  'zkur.venýho',
  'zkurvili',
  'zkurvy',
  'zkurvysynu',
  'zkurwený',
  'zm*di',
  'z.m.rd',
  'zm.r.d',
  'zm.rd',
  'zmrd',
  'Z.M.R.D',
  'zm.rda',
  'zmr-da',
  'zm-r-de',
  'zmr..de',
  'zmr.de',
  'zm..rdovi',
  'zmrrd',
  'zumail',
]